import { HistoryTerm } from '@empathy/search-types';
import { StorageService } from '@empathy/storage-service';
import { container } from '../../../container';
import { DEPENDENCIES, STORAGE } from '../../../container/dependencies.const';
import { normalizeString } from '../../../utils';
import { HISTORY_ACTIONS_KEYS, HISTORY_MUTATIONS_KEYS, historyItemStrategy, MAX_QUERY_HISTORY_SIZE } from '../history.const';
import { HistoryAction, HistoryContext } from '../history.interfaces';
import { getHistoryItemStrategy } from '../history.utils';

export class AddQueryHistoryAction implements HistoryAction {

  private storageService: StorageService;

  actions = {
    [HISTORY_ACTIONS_KEYS.addQueryHistory]: ({ commit, state, getters }: HistoryContext, historyTerm: string): any => {
      if (state.queryHistoryEnabled) {
        const queryHistory = this.generateNewHistory(state.queryHistory, historyTerm.trim());
        queryHistory.splice(MAX_QUERY_HISTORY_SIZE);
        this.saveHistoryToStorage(getters.storageKey, queryHistory);
        commit(HISTORY_MUTATIONS_KEYS.setQueryHistory, queryHistory);
      }
    }
  };

  protected generateNewHistory(oldHistory: HistoryTerm[], newTerm: string): HistoryTerm[] {
    const normalizedNewTerm = normalizeString(newTerm);
    const currentHistoryItemStrategy = getHistoryItemStrategy(normalizedNewTerm, normalizeString(oldHistory[0]?.term));
    const newHistory = oldHistory.filter((historyItem, index) => index === 0 || normalizeString(historyItem.term) !== normalizedNewTerm);

    if (currentHistoryItemStrategy === historyItemStrategy.add) {
      newHistory.unshift(this.mapSuggestion(newTerm));
    } else if (currentHistoryItemStrategy === historyItemStrategy.replace) {
      newHistory[0] = this.mapSuggestion(newTerm);
    }
    return newHistory;
  }

  protected saveHistoryToStorage(key: string, history: HistoryTerm[]) {
    this.storageService = this.storageService ?? container.getNamed<StorageService>(DEPENDENCIES.StorageService, STORAGE.Local);
    this.storageService.setItem(key, history);
  }

  protected mapSuggestion(term: string): HistoryTerm {
    return {
      modelName: 'History',
      term,
      timestamp: Date.now()
    };
  }
}
